import * as yup from 'yup'

const contentSettingsFormValidationSchema = yup
  .object({
    max_ml_suggestions: yup
      .number()
      .label('Maximum number of answer suggestions')
      .typeError(({ label, type }) => `${label} value must be a ${type}`)
      .integer(({ label }) => `${label} should not be a decimal number`)
      .min(1, ({ label, min }) => `${label} should be atleast ${min}`)
      .max(10, ({ label, max }) => `${label} should not exceed ${max}`)
  })
  .required()

export default contentSettingsFormValidationSchema
